import {inject, InjectionToken, Pipe, PipeTransform} from '@angular/core';
import {WeightLevel} from '../constants/weight-level.enum';

// Accepted types
export type SdLevel = 'SD3-' | 'SD2-' | 'SD1-' | 'SD0' | 'SD1' | 'SD2' | 'SD3';

// Rótulos de Peso × Edad — casam EXATAMENTE com WeightLevel (mesmo texto vai
// para o Firebase em visit.weightLevel).
export const SD_LEVEL_LABELS = new InjectionToken<
    Partial<Record<SdLevel, string>>
>('SD_LEVEL_LABELS', {
    factory: () => ({
        'SD3-': WeightLevel.LOW_LEVEL_INDICATOR,          // 'Bajo peso severo'
        'SD2-': WeightLevel.MIDDLE_LOW_LEVEL_INDICATOR,   // 'Bajo peso moderado'
        'SD1-': WeightLevel.NORMAL_LEVEL,                 // 'Normal'
        'SD0': WeightLevel.NORMAL_LEVEL,
        'SD1': WeightLevel.NORMAL_LEVEL,
        'SD2': WeightLevel.PROBABLY_OVERWEIGHT,           // 'Probable obesidad'
        'SD3': WeightLevel.OBESITY,                       // 'Obesidad'
    }),
});

@Pipe({
    name: 'weightMalnutritionLevel',
    pure: true,
})
export class WeightMalnutritionLevelPipe implements PipeTransform {
    private labels = inject(SD_LEVEL_LABELS);

    /**
     * @param value  Nível SD (ex.: 'SD2-')
     * @param fallback Texto opcional caso não exista rótulo (default: próprio value)
     */
    transform(value: SdLevel | string | null | undefined, fallback?: string): string {
        if (!value) {
            return fallback ?? 'No medido';
        }
        const v = value as SdLevel;
        return this.labels[v] ?? fallback ?? String(value);
    }
}
